import { css } from '@emotion/react';
import { theme } from '../../theme/theme';
import type { BadgeTone } from './Badge';

const toneColor: Record<BadgeTone, string> = {
  neutral: theme.color.textMuted,
  success: theme.color.success,
  danger: theme.color.danger,
  info: theme.color.running,
  secondary: theme.color.secondary,
};

export const badgeStyle = (tone: BadgeTone) => css`
  display: inline-flex;
  align-items: center;
  padding: ${theme.space.xs / 2}px ${theme.space.sm}px;
  border-radius: ${theme.radius.pill}px;
  font-size: ${theme.fontSize.sm}px;
  font-weight: 500;
  background: ${toneColor[tone]}1A;
  color: ${toneColor[tone]};
`;
